import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';

import type { Action, ThunkAction } from 'types';

const { getInfluencersWithDuplicatedChannels } = API.END_POINTS.ADMIN;

const PROFILES_LOADED = 'admin/DUPLICATED_PROFILES_LOADED';
const PROFILES_RESET = 'admin/DUPLICATED_PROFILES_RESET';

const initialState = {
  duplicateProfiles: {},
  isLoading: true
};

function profilesLoaded(data): Action {
  return {
    type: PROFILES_LOADED,
    payload: {
      data
    }
  };
}

export function resetProfilesWithDuplicatedChannels(): Action {
  return {
    type: PROFILES_RESET
  };
}

export function fetchProfilesWithDuplicatedChannels(profileId: number): ThunkAction {
  const url = getInfluencersWithDuplicatedChannels(profileId);
  return (dispatch) => get(url)
    .then(response => dispatch(profilesLoaded({ [`${profileId}`]: response.data.duplicateChannelProfiles })));
}

export default createReducer<any, any>('adminDuplicatedProfiles', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [PROFILES_RESET]: (state) => ({
    ...state,
    duplicateProfiles: {}
  }),
  [PROFILES_LOADED]: (state, { data }) => ({
    ...state,
    duplicateProfiles: {
      ...state.duplicateProfiles,
      ...data
    }
  })
});
